import { parse as parseParams } from 'query-string';
import { SettingsClient } from './settings-client';
import { AppClient } from './app-client';
import { JsSdkAdapter } from './js-sdk-adapter';
import { HttpApiClient } from './http-api-client';
import { Scope } from './domain';
import { assert, resolve } from './utils/checks';
import { CdnApiClient } from './cdn-api-client';
function settingsClient(opts) {
    assertClientInput(opts);
    var scope = opts.scope, data = opts.data;
    var adapter = opts.adapter || adapters.wixSdk();
    var settingsApiUrl = resolve(opts.apiUrl, getApiUrl, 'could not resolve apiUrl - please provide it explicitly');
    return new SettingsClient({
        adapter: adapter,
        scope: scope,
        data: data,
        apiClient: new HttpApiClient(settingsApiUrl)
    });
}
function appClient(opts) {
    assertClientInput(opts);
    var scope = opts.scope, data = opts.data;
    var adapter = opts.adapter || adapters.wixSdk();
    var settingsApiUrl = opts.cdnUrl;
    return new AppClient({
        adapter: adapter,
        scope: scope,
        data: data,
        cdnClient: new CdnApiClient({ baseCdnUrl: settingsApiUrl })
    });
}
var adapters = {
    wixSdk: function (_a) {
        var _b = _a === void 0 ? {} : _a, jsSdkInstance = _b.jsSdkInstance, signedInstance = _b.signedInstance;
        return new JsSdkAdapter({
            jsSdkInstance: resolve(jsSdkInstance, getWixSdk, 'window.Wix is undefined, please specify jsSdkInstance'),
            signedInstance: resolve(signedInstance, getInstance, 'no instance in query parameters, please specify signedInstance'),
        });
    }
};
function assertClientInput(opts) {
    assert(opts !== undefined, 'opts is mandatory');
    assert(opts.scope !== undefined, 'scope is mandatory');
    assert(opts.scope === Scope.COMPONENT || opts.scope === Scope.APP, 'scope must be APP or COMPONENT');
    assert(opts.scope === Scope.COMPONENT, 'APP scope is not supported');
}
function getWixSdk() {
    return window.Wix;
}
function getInstance() {
    return parseParams(window.location.search).instance;
}
function getApiUrl() {
    return "".concat(window.location.origin, "/_api/app-settings-service");
}
export { settingsClient, appClient, adapters, SettingsClient, AppClient, JsSdkAdapter, Scope };
//# sourceMappingURL=index.js.map